import i18n, { t } from "i18next";
import {
    BuildingModalIcon,
    DescriptionTittle,
    DetailsIconsOptions,
    DownloadIcon, IconLoadingNotification, IconRequestTitleNotification
} from "../../../../components/buttons/IconButtons";
import { getModelKeyById } from "../../../../Apis/Models";
import { Trans } from "react-i18next";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import routes from "../../../../Routes/routes";
import { DownloadReportByName } from "../../../../reduxToolkit/Reports/ReportApi";
import { RequestMarkFilesAsRead } from "../../../../reduxToolkit/ApprovalTracker/ApprovalTrackerApi";
import { toast } from "react-toastify";
import { TABS_VISITOR } from "../../Visitor/Model/Model";
import { VISITOR_SUB_VIEW_MODEL } from "../../Visitor/Invitation/Model/Model";
import { RESERVATIONS_SUB_VIEW_MODEL, TABS_RESERVATIONS } from "../../Events/Model/Model";
import {calculateTime, getDateFormat} from "../../../../Apis/functions";
import {errorCodeTranslation} from "../../../../Apis/ErrorCode";
import {status} from "../../../../enums/statusEnum";
import {STATUS_MODEL} from "../../../../enums/statusEnum";
import {TABLES} from "../../../../Apis/Tables";
import {PROFILE_MODEL} from "../../../DocumentationApprovalFlow/Model/Model";
import {USER_TYPE_MODEL} from "../../../../enums/userTypeEnum";
import {SUB_VIEW_MODEL as ORDERS_SUB_VIEW_MODEL, TABS_FOODIE_ORDERS} from "../../DiningOrders/Model/Models";


/**
 * @typedef {Object} NotificationItem
 * @property {number} id - Unique identifier for the notification.
 * @property {string} translation - Translation key associated with the notification type.
 * @property {JSX.Element | null} icon - Icon to display (can be a React component or null).
 */

/**
 * List of available notification items.
 * @type {NotificationItem[]}
 */
export const NOTIFICATION_TABS_MODEL = {
    ALL: {
        id: 1,
        name: "ALL"
    },
    REQUEST: {
        id: 2,
        name: "REQUEST"
    },
    REPORTS: {
        id: 3,
        name: "REPORTS"
    },
    VISITORS: {
        id: 4,
        name: "VISITORS"
    }
};

/**
 * Notification type discriminator sent by the back for each request card.
 * Mirrors ApprovalRequestNotificationType on the back.
 */
export const REQUEST_NOTIFICATION_TYPE = {
    DINNING_APPROVAL: "dinning_approval",
    RESERVATION_APPROVAL: "reservation_approval",
    INVITATION_APPROVAL: "invitation_approval",
    CONTRACTOR_COMPANY: "contractor_company",
    CONTRACTOR_EMPLOYEE: "contractor_employee",
    CONTRACTOR_VEHICLE: "contractor_vehicle",
    SUPPLIER_COMPANY: "supplier_company",
    SUPPLIER_EMPLOYEE: "supplier_employee",
    SUPPLIER_VEHICLE: "supplier_vehicle",
    // Requester facing cards: sent to whoever submitted the request once it is
    // resolved, not to the approvers.
    DOCUMENTATION_COMPANY_APPROVED: "documentation_company_approved",
    DOCUMENTATION_COMPANY_DENIED: "documentation_company_denied",
    DOCUMENTATION_COMPANY_CHANGES_REQUESTED: "documentation_company_changes_requested",
    DOCUMENTATION_EMPLOYEE_APPROVED: "documentation_employee_approved",
    DOCUMENTATION_EMPLOYEE_DENIED: "documentation_employee_denied",
    DOCUMENTATION_EMPLOYEE_CHANGES_REQUESTED: "documentation_employee_changes_requested",
    DOCUMENTATION_VEHICLE_APPROVED: "documentation_vehicle_approved",
    DOCUMENTATION_VEHICLE_DENIED: "documentation_vehicle_denied",
    DOCUMENTATION_VEHICLE_CHANGES_REQUESTED: "documentation_vehicle_changes_requested",
    DINNING_APPROVED: "dinning_approved",
    DINNING_DENIED: "dinning_denied",
    DINNING_CHANGES_REQUESTED: "dinning_changes_requested",
    RESERVATION_APPROVED: "reservation_approved",
    RESERVATION_DENIED: "reservation_denied",
    RESERVATION_CHANGES_REQUESTED: "reservation_changes_requested",
    INVITATION_APPROVED: "invitation_approved",
    INVITATION_DENIED: "invitation_denied",
    INVITATION_CHANGES_REQUESTED: "invitation_changes_requested",
};

const REQUEST_NAV_TYPE = {
    TRACKER: "tracker",
    DOCUMENT: "document",
    OWN_DOCUMENT: "own_document",
    REQUEST_MEALS: "request_meals",
    ONGOING_INVITATIONS: "ongoing_invitations",
    REQUESTED_BOOKINGS: "requested_bookings",
};

/**
 * Per notification type card definition. `dynamic` cards interpolate the level
 * name, requester and request name into the description; the rest use a static
 * description, which is every card whose text names nothing (the meal decisions,
 * addressed to whoever made the request).
 *
 * `navType` decides where the card's action button lands. A card without one
 * (an unknown type sent by the back) renders no button.
 */
export const REQUEST_NOTIFICATION_CARDS = {
    [REQUEST_NOTIFICATION_TYPE.DINNING_APPROVAL]: {
        title: "dinning_extra_meal_requested",
        description: "an_additional_meal_request_for_requested_on_date_subject_has_been_submitted_please_review_and_confirm",
        descriptionWithoutSubject: "an_additional_meal_request_for_requested_on_date_has_been_submitted_please_review_and_confirm",
        navType: REQUEST_NAV_TYPE.TRACKER,
        module: TABLES.FOODIE_REQUEST,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.RESERVATION_APPROVAL]: {
        title: "reservation_approval_needed",
        description: "the_reservation_subject_is_pending_your_approval_in_the_tracker_please_take_action_to_proceed",
        navType: REQUEST_NAV_TYPE.TRACKER,
        module: TABLES.EVENT,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.INVITATION_APPROVAL]: {
        title: "invitation_approval_needed",
        description: "an_invitation_for_requested_from_subject_is_pending_your_approval_take_action_to_proceed",
        descriptionWithoutSubject: "an_invitation_for_requested_is_pending_your_approval_take_action_to_proceed",
        navType: REQUEST_NAV_TYPE.TRACKER,
        module: TABLES.USER_INVITATION,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.CONTRACTOR_COMPANY]: {
        title: "company_documentation_approval_pending",
        description: "you_are_next_in_the_approval_flow_for_name_from_requested",
        navType: REQUEST_NAV_TYPE.DOCUMENT,
        userType: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        profile: PROFILE_MODEL.COMPANY,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.CONTRACTOR_EMPLOYEE]: {
        title: "employee_documentation_approval_pending",
        description: "you_are_next_in_the_approval_flow_for_name_from_requested",
        navType: REQUEST_NAV_TYPE.DOCUMENT,
        userType: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        profile: PROFILE_MODEL.EMPLOYEE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.CONTRACTOR_VEHICLE]: {
        title: "vehicle_documentation_approval_pending",
        description: "you_are_next_in_the_approval_flow_for_name_from_requested",
        navType: REQUEST_NAV_TYPE.DOCUMENT,
        userType: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        profile: PROFILE_MODEL.VEHICLE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.SUPPLIER_COMPANY]: {
        title: "company_documentation_approval_pending",
        description: "you_are_next_in_the_approval_flow_for_name_from_requested",
        navType: REQUEST_NAV_TYPE.DOCUMENT,
        userType: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        profile: PROFILE_MODEL.COMPANY,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.SUPPLIER_EMPLOYEE]: {
        title: "employee_documentation_approval_pending",
        description: "you_are_next_in_the_approval_flow_for_name_from_requested",
        navType: REQUEST_NAV_TYPE.DOCUMENT,
        userType: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        profile: PROFILE_MODEL.EMPLOYEE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.SUPPLIER_VEHICLE]: {
        title: "vehicle_documentation_approval_pending",
        description: "you_are_next_in_the_approval_flow_for_name_from_requested",
        navType: REQUEST_NAV_TYPE.DOCUMENT,
        userType: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        profile: PROFILE_MODEL.VEHICLE,
        dynamic: true,
    },

    // ---- Requester facing cards ---- //
    // Documentation decisions reach the contractor / supplier in charge, who may
    // own several documented subjects, so the title names the profile and
    // `requestedByName` names the employee or vehicle plate the decision is
    // about. On a denial or a change request `departmentName` names the
    // department that acted and `levelName` the document it acted on.
    // Company documentation belongs to the reader, so it is addressed in second
    // person and drops the redundant subject name. Approving it activates the
    // user, which only takes effect on a new session.
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_COMPANY_APPROVED]: {
        title: "company_documentation_approved",
        description: "your_documentation_was_approved_sign_in_again_to_access_the_unlocked_modules",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.COMPANY,
        dynamic: false,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_COMPANY_DENIED]: {
        title: "company_documentation_denied",
        description: "the_department_denied_your_document_name_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.COMPANY,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_COMPANY_CHANGES_REQUESTED]: {
        title: "company_documentation_requires_changes",
        description: "the_department_requested_changes_on_your_document_name_please_review_and_proceed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.COMPANY,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_EMPLOYEE_APPROVED]: {
        title: "employee_documentation_approved",
        description: "the_documentation_for_requested_was_approved_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.EMPLOYEE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_EMPLOYEE_DENIED]: {
        title: "employee_documentation_denied",
        description: "the_department_denied_the_document_name_for_requested_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.EMPLOYEE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_EMPLOYEE_CHANGES_REQUESTED]: {
        title: "employee_documentation_requires_changes",
        description: "the_department_requested_changes_on_the_document_name_for_requested_please_review_and_proceed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.EMPLOYEE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_VEHICLE_APPROVED]: {
        title: "vehicle_documentation_approved",
        description: "the_documentation_for_requested_was_approved_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.VEHICLE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_VEHICLE_DENIED]: {
        title: "vehicle_documentation_denied",
        description: "the_department_denied_the_document_name_for_requested_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.VEHICLE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DOCUMENTATION_VEHICLE_CHANGES_REQUESTED]: {
        title: "vehicle_documentation_requires_changes",
        description: "the_department_requested_changes_on_the_document_name_for_requested_please_review_and_proceed",
        navType: REQUEST_NAV_TYPE.OWN_DOCUMENT,
        profile: PROFILE_MODEL.VEHICLE,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DINNING_APPROVED]: {
        title: "your_meal_request_was_approved",
        description: "your_meal_request_for_date_subject_was_approved_no_further_action_is_needed",
        descriptionWithoutSubject: "your_meal_request_for_date_was_approved_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.REQUEST_MEALS,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DINNING_DENIED]: {
        title: "your_meal_request_was_denied",
        description: "your_meal_request_for_date_subject_was_denied_no_further_action_is_needed",
        descriptionWithoutSubject: "your_meal_request_for_date_was_denied_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.REQUEST_MEALS,
        subView: ORDERS_SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.DINNING_CHANGES_REQUESTED]: {
        title: "your_meal_request_requires_changes",
        description: "approver_requested_changes_on_your_meal_request_for_date_subject_please_review_and_proceed",
        descriptionWithoutSubject: "approver_requested_changes_on_your_meal_request_for_date_please_review_and_proceed",
        navType: REQUEST_NAV_TYPE.REQUEST_MEALS,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.RESERVATION_APPROVED]: {
        title: "your_reservation_was_approved",
        description: "your_reservation_subject_was_approved_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.REQUESTED_BOOKINGS,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.RESERVATION_DENIED]: {
        title: "your_reservation_was_denied",
        description: "your_reservation_subject_was_denied_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.REQUESTED_BOOKINGS,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.RESERVATION_CHANGES_REQUESTED]: {
        title: "your_reservation_requires_changes",
        description: "your_reservation_subject_requires_changes_please_review_and_proceed",
        navType: REQUEST_NAV_TYPE.REQUESTED_BOOKINGS,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.INVITATION_APPROVED]: {
        title: "invitation_approved",
        description: "your_invitation_for_requested_was_approved_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.ONGOING_INVITATIONS,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.INVITATION_DENIED]: {
        title: "invitation_approval_denied",
        description: "your_invitation_approval_for_requested_was_denied_no_further_action_is_needed",
        navType: REQUEST_NAV_TYPE.ONGOING_INVITATIONS,
        dynamic: true,
    },
    [REQUEST_NOTIFICATION_TYPE.INVITATION_CHANGES_REQUESTED]: {
        title: "invitation_approval_requires_changes",
        description: "your_invitation_approval_for_requested_requires_changes_please_review_and_proceed",
        navType: REQUEST_NAV_TYPE.ONGOING_INVITATIONS,
        dynamic: true,
    },
};

/**
 * Navigates to the approval location of a request notification: the approval
 * tracker for dinning / reservation / invitation, or the documentation request
 * detail for contractor / supplier flows.
 */
/**
 * Navigates a documentation decision card to the requester's own documentation
 * screen. The card is only ever addressed to a contractor or a supplier, so the
 * route family is taken from whichever session the reader is in. On employee and
 * vehicle profiles `requestedById` carries the documented user or vehicle id the
 * screen expects.
 */
const navigateToOwnDocumentation = (navigate, data, card, refreshedAt) => {
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    if (!contractorId && !supplierId) return;

    const base = contractorId ? routes.contractor : routes.suppliers;
    // The documentation screen goes back to whatever the state carries, and a
    // notification is not a view to return to, so the list the documented subject
    // belongs to is sent instead, the same one the module views send.
    const listUrl = card.profile === PROFILE_MODEL.EMPLOYEE
        ? (contractorId ? routes.contractor.searchEmployee : routes.suppliers.employees)
        : (contractorId ? routes.vehicleContractor.search : routes.suppliers.vehicleFleet);

    if (card.profile === PROFILE_MODEL.COMPANY) {
        // Own company documentation is reached from the menu, not from a list.
        navigate(base.companyDocumentation, { state: { refreshedAt } });
        return;
    }
    if (!data?.requestedById) return;
    navigate(card.profile === PROFILE_MODEL.EMPLOYEE
        ? `${base.employeeDocumentation}${data.requestedById}`
        : `${base.vehicleDocumentation}${data.requestedById}`,
        { state: { refreshedAt, backUrl: listUrl } });
};

const navigateToRequest = (navigate, data, card) => {
    if (!card) return;

    // The reader may already be standing on the destination, where navigating to
    // the same path changes nothing on its own. Every destination carries a nonce
    // so it can tell a fresh arrival apart and re-fetch what was just notified.
    const refreshedAt = Date.now();

    if (card.navType === REQUEST_NAV_TYPE.OWN_DOCUMENT) {
        navigateToOwnDocumentation(navigate, data, card, refreshedAt);
        return;
    }
    if (card.navType === REQUEST_NAV_TYPE.REQUEST_MEALS) {
        // The reader owns the request, not the flow: the tracker is the approvers'
        // view and is gated by their read permission, so the decision lands on the
        // reader's own meal requests instead. A denied request is no longer active,
        // so its card carries the subview that holds it.
        navigate(routes.foodieOrders.main, {
            state: {
                currentTab: TABS_FOODIE_ORDERS.REQUEST_MEALS.INDEX,
                subView: card.subView || ORDERS_SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE,
                refreshedAt,
            },
        });
        return;
    }
    if (card.navType === REQUEST_NAV_TYPE.ONGOING_INVITATIONS) {
        // The host owns the invitation, not the flow, so the decision lands on
        // their ongoing invitations. The view sends whoever cannot read that tab
        // to the forbidden page on its own.
        navigate(routes.visitor.list, {
            state: {
                currentTab: TABS_VISITOR.INVITATIONS.INDEX,
                currentSubView: VISITOR_SUB_VIEW_MODEL.INVITATION.ONGOING,
                refreshedAt,
            },
        });
        return;
    }
    if (card.navType === REQUEST_NAV_TYPE.REQUESTED_BOOKINGS) {
        // Same as the invitations: the host owns the reservation, not the flow, so
        // the decision lands on their requested bookings and the view sends whoever
        // cannot read that tab to the forbidden page.
        navigate(routes.event.list, {
            state: {
                currentTab: TABS_RESERVATIONS.BOOKINGS.INDEX,
                currentSubView: RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST,
                refreshedAt,
            },
        });
        return;
    }
    if (card.navType === REQUEST_NAV_TYPE.TRACKER) {
        // No backUrl on purpose: the notification is not a view to go back to, so
        // the tracker resolves the module view the user is allowed to land on.
        navigate(`${routes.approvalTracker.main}${card.module}/${data?.subjectId}/${data?.approvalFlowId}`, {
            state: { refreshedAt },
        });
        return;
    }
    const baseRoute = card.userType === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE
        ? routes.employee.documentRequestDetailsContractor
        : routes.employee.documentRequestDetailsSupplier;
    navigate(`${baseRoute}${data?.requestedById}/${card.profile}`, {
        state: { userType: card.userType, refreshedAt },
    });
};

export const NOTIFICATION_ITEM_MODEL = {

    ALL: {
        ...NOTIFICATION_TABS_MODEL.ALL
    },
    REQUEST: {
        ...NOTIFICATION_TABS_MODEL.REQUEST,
        key: "REQUEST",
        icon: <IconRequestTitleNotification className="h-20px w-20px" />,
        title: "",
        elementName: "",
        description: "",
        elapsedTime: null,
        orderTime: 0,
        value: null,
        read: false,
        readIndicatorClass: "border-full-shades-100 background-shades-50",
        unreadIndicatorClass: "border-full-warning-500 background-warning-100",
        iconClass: "background-warning-100",
        getButton: ({handleToggle,navigate }) => {
            return <ButtonAction
                Icon={DownloadIcon}
                iconProps="mx-1"
                name={"review_request"}
                splitName={false}
                className="btn-background-transparent-shades-300 btn-no-shadow"
                onClick={(e) => {
                    e?.stopPropagation();
                    handleToggle();
                    navigate(routes.approvalTracker.main)
                }
                }
            />
        },

    },
    REPORTS: {
        ...NOTIFICATION_TABS_MODEL.REPORTS,
        key: "REPORTS",
        icon: <DescriptionTittle className="icon-color-general-950 h-20px w-20px" />,
        title: "",
        elementName: "",
        description: "",
        elapsedTime: null,
        orderTime: 0,
        value: null,
        read: false,
        readIndicatorClass: "border-full-shades-100 background-shades-50",
        unreadIndicatorClass: "border-full-primary-500 background-primary-100",
        iconClass: "background-primary-100",
        getButton: ({ dispatch, value, handleToggle }) => {
            return <ButtonAction
                Icon={DownloadIcon}
                iconProps="mx-1"
                name={"DOWNLOAD_DOCUMENT"}
                splitName={false}
                className="btn-background-transparent-shades-300 btn-no-shadow"
                onClick={() => {
                    handleToggle();
                    dispatch(DownloadReportByName({ name: value })).then(
                        ({ payload: { data: { success } } }) => {
                            if (success === true) {
                                toast.success(t("has_been_downloaded_successfully"));
                            }
                        }
                    );
                }
                }
            />
        },

    },
    REQUEST_ACCESS: {
        ...NOTIFICATION_TABS_MODEL.VISITORS,
        key: "REQUEST_ACCESS",
        icon: <BuildingModalIcon className="h-20px w-20px" />,
        title: "visitor_access_request",
        elementName: "",
        description: "has_request_access_review_and_approve_the_request",
        elapsedTime: null,
        orderTime: 0,
        value: null,
        read: false,
        readIndicatorClass: "border-full-shades-100 background-shades-50",
        unreadIndicatorClass: "border-full-secondary-500 background-secondary-100",
        iconClass: "background-secondary-100",
        getButton: ({ navigate, handleToggle }) => {
            return <ButtonAction
                Icon={DetailsIconsOptions}
                name={"review_requests"}
                splitName={false}
                className="btn-background-transparent-shades-300 btn-no-shadow"
                iconProps='btn-icon-svg-20px'
                onClick={() => {
                    handleToggle();
                    navigate(routes.visitor.list, {
                        state: { currentTab: TABS_VISITOR.VISITORS.INDEX, currentSubView: VISITOR_SUB_VIEW_MODEL.VISITORS.ACTIVE_REQUESTS },
                    });
                }}
            />
        }
    },
    USER_INVITATION: {
        ...NOTIFICATION_TABS_MODEL.VISITORS,
        key: "USER_INVITATION",
        icon: <BuildingModalIcon className="h-20px w-20px" />,
        title: "your_visitor_has_arrived",
        elementName: "",
        description: "is_at_reception_and_ready_to_enter",
        elapsedTime: null,
        orderTime: 0,
        value: null,
        read: false,
        readIndicatorClass: "border-full-shades-100 background-shades-50",
        unreadIndicatorClass: "border-full-warning-500 background-warning-100",
        iconClass: "background-warning-100",
        getButton: null,
    },
    sort: function (list) {
        if (!list) return list;
        return list?.sort((a, b) => new Date(b.orderTime) - new Date(a.orderTime));
    },
    set: function (data, key) {
        let getButton = this[key].getButton;
        let title = i18n.t(this[key].title);
        let value = i18n.t(this[key].value);
        let read;
        let description;
        let orderTime;
        let icon;

        if (key === NOTIFICATION_ITEM_MODEL.REPORTS.key) {
            read = data.isFileViewed;
            let reportName = i18n.t(getModelKeyById(data.moduleId));
            // Report names may contain characters i18next escapes (e.g. "equipo/material"),
            // React already escapes the rendered output.
            title = i18n.t(status[data.statusId], { name: reportName, interpolation: { escapeValue: false } });
            value = data?.path;
            orderTime = data.endAt;

            if(data?.statusId === STATUS_MODEL.REPORT_GENERATING){
                getButton = null;
                description = <Trans
                    i18nKey={"your_report_is_generating"}
                    values={{ name: reportName }}
                    tOptions={{ interpolation: { escapeValue: false } }}
                />
                icon = <IconLoadingNotification className="icon-color-general-950 btn-icon-svg-20px loader" />
                orderTime = data.startAt;
            }
            else if(data?.statusId === STATUS_MODEL.REPORT_EXPIRED){
                getButton = null;
                description = <Trans
                    i18nKey={"your_report_is_expired"}
                    values={{ name: value }}
                    components={{ bold: <strong /> }}
                />
                icon = <DescriptionTittle className="icon-color-general-950 btn-icon-svg-20px" />
                orderTime = data.startAt;
            }
            else {
                if (errorCodeTranslation[data.path]) {
                    getButton = null;
                    description = <Trans
                        i18nKey={errorCodeTranslation[data.path]}
                        values={{ name: reportName }}
                        tOptions={{ interpolation: { escapeValue: false } }}
                    />
                    icon = <DescriptionTittle className="icon-color-general-950 btn-icon-svg-20px" />
                }
                else {
                    description = <Trans
                        i18nKey="your_report_is_ready"
                        values={{ name: value }}
                        components={{ bold: <strong /> }}
                    />;
                    icon = <DescriptionTittle className="icon-color-general-950 btn-icon-svg-20px" />
                }
            }
        }
        else if (key === NOTIFICATION_ITEM_MODEL.REQUEST.key) {
            const card = REQUEST_NOTIFICATION_CARDS[data?.notificationType];
            read = data?.isFileViewed;
            orderTime = data?.createdAt;
            title = i18n.t(card?.title);
            icon = <IconRequestTitleNotification className="btn-icon-svg-20px" />;

            if (card?.dynamic) {
                // A request without a name of its own (a meal with no serving time
                // assigned) drops that part of the sentence instead of leaving a hole.
                const descriptionKey = !data?.subjectName && card.descriptionWithoutSubject
                    ? card.descriptionWithoutSubject
                    : card.description;

                description = <Trans
                    i18nKey={descriptionKey}
                    values={{
                        name: data?.levelName,
                        department: data?.departmentName,
                        requested: data?.requestedByName,
                        subject: data?.subjectName,
                        date: getDateFormat(data?.subjectDate, false, 'shortMonth'),
                    }}
                    // Without it the slashes of the date come out as &#x2F;: the
                    // values are rendered as text by react, so escaping them again
                    // only shows the entities.
                    tOptions={{ interpolation: { escapeValue: false } }}
                    components={{ bold: <strong /> }}
                />;
            } else {
                description = i18n.t(card?.description);
            }

            // An unknown card type has no destination, so it renders no button.
            getButton = !card?.navType ? null : ({ navigate, handleToggle, dispatch }) => {
                return <ButtonAction
                    Icon={DownloadIcon}
                    iconProps="mx-1"
                    name={"review_request"}
                    splitName={false}
                    className="btn-background-transparent-shades-300 btn-no-shadow"
                    onClick={(e) => {
                        // Stop propagation so the card's onMarkAsRead (which toasts)
                        // does not fire; mark this notification read silently instead.
                        e?.stopPropagation();
                        if (!data?.isFileViewed) dispatch(RequestMarkFilesAsRead([data?.id]));
                        handleToggle();
                        navigateToRequest(navigate, data, card);
                    }}
                />;
            };
        }
        else if (key === NOTIFICATION_ITEM_MODEL.USER_INVITATION.key) {
            read = data.isViewed === 2;
            orderTime = data.updatedAt;
            description = <Trans
                i18nKey={this[key].description}
                values={{ name: data?.visitorName + " " + data?.visitorLastName + (data?.visitorSecondLastName ? (" " + data?.visitorSecondLastName) : "") }}
                components={{ bold: <strong /> }}
            />;
            icon = <BuildingModalIcon className="btn-icon-svg-20px" />
        }
        else {
            // Visitor access requests carry a boolean, not the numeric flag the
            // invitations use.
            read = Boolean(data.isViewed);
            orderTime = data?.actionTakenAt || data?.createdAt;
            description = <Trans
                i18nKey={this[key].description}
                values={{ name: data?.requestedByName + " " + data?.requestedByLastName + (data?.requestedBySecondLastName ? (" " + data?.requestedBySecondLastName) : "") }}
                components={{ bold: <strong /> }}
            />;
            icon = <BuildingModalIcon className="btn-icon-svg-20px" />
        }

        return {
            ...this[key],
            title: title,
            id: data.id,
            elementName: "",
            description: description,
            elapsedTime: calculateTime(orderTime),
            orderTime: orderTime,
            getButton: getButton,
            value: value,
            read: read,
            icon,
            readIndicatorClass: read ? this[key].readIndicatorClass : this[key].unreadIndicatorClass
        }
    },
}

const contractorId = sessionStorage.getItem('contractorId');
const supplierId = sessionStorage.getItem('providerId');

export const notificationsItems = [
    {
        id: NOTIFICATION_TABS_MODEL.ALL.id,
        key: NOTIFICATION_TABS_MODEL.ALL.name,
        translation: "all",
        icon: null
    },
    {
        id: NOTIFICATION_TABS_MODEL.REQUEST.id,
        key: NOTIFICATION_TABS_MODEL.REQUEST.name,
        translation: "requests",
        icon: <IconRequestTitleNotification className="btn-icon-svg-20px" />,
    },
    {
        id: NOTIFICATION_TABS_MODEL.REPORTS.id,
        key: NOTIFICATION_TABS_MODEL.REPORTS.name,
        translation: "reports",
        icon: <DescriptionTittle className="icon-color-general-950 btn-icon-svg-20px" />,
    },
    {
        id: NOTIFICATION_TABS_MODEL.VISITORS.id,
        key: NOTIFICATION_TABS_MODEL.VISITORS.name,
        translation: "visitors",
        icon: <BuildingModalIcon className="btn-icon-svg-20px" />,
    },
];

export const visibleNotificationsItems = notificationsItems.filter(
    (item) =>
         !(
            (contractorId || supplierId) &&
            item.key === NOTIFICATION_TABS_MODEL.VISITORS.name
        )
);

export const ALLOWED_NOTIFICATION_ROUTES = [
    "dashboard/employee",
    "dashboard/contractor",
    "dashboard/supplier",
    "login-option"
]
